<template>
  <div>
    <Head title="Customers" />
    <h1 class="mb-8 text-3xl font-bold">Customers</h1>
    <div class="flex items-center justify-between mb-6">
      <search-filter v-model="form.search" class="mr-4 w-full max-w-md" @reset="reset" />
      <Link class="btn-orange" href="/customers/create">
        <span>Create</span>
        <span class="hidden md:inline">&nbsp;</span>
      </Link>
    </div>
    <hr />
    <ul
      id="tabs-tabFill"
      class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
      role="tablist"
    >
      <li class="nav-item flex-auto text-center" role="presentation">
        <a
          id="tabs-home-tabFill"
          href="#tabs-homeFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent
          active" 
          data-bs-toggle="pill" 
          data-bs-target="#tabs-homeFill" 
          role="tab"
          aria-controls="tabs-homeFill"
          aria-selected="true"
        >
          Pending
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a 
          id="tabs-profile-tabFill"
          href="#tabs-profileFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-profileFill"
          role="tab"
          aria-controls="tabs-profileFill"
          aria-selected="false"
        >
          Approved
        </a>
      </li>
      <li
        class="nav-item flex-auto text-center"
        role="presentation"
      >
        <a 
          id="tabs-declined-tabFill"
          href="#tabs-declinedFill"
          class="
          nav-link
          w-full
          block
          font-medium
          text-xs
          leading-tight
          uppercase
          border-x-0 border-t-0 border-b-2 border-transparent
          px-6
          py-3
          my-2
          hover:border-transparent hover:bg-gray-100
          focus:border-transparent"
          data-bs-toggle="pill"
          data-bs-target="#tabs-declinedFill"
          role="tab"
          aria-controls="tabs-declinedFill"
          aria-selected="false"
        >
          Declined
        </a>
      </li>
    </ul>
    <div id="tabs-tabContentFill" class="tab-content">
      <div id="tabs-homeFill" class="tab-pane fade show active" role="tabpanel" aria-labelledby="tabs-home-tabFill">
        <div v-if="pending.data.length > 0" class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Created on</th>
              <th class="pb-3 pt-3 px-3">Number</th>
              <th class="pb-3 pt-3 px-3">Name</th>
              <th class="pb-3 pt-3 px-3">Channel</th>
              <th class="pb-3 pt-3 px-3">Physcial Address</th>
              <th class="pb-3 pt-3 px-3">Contact</th>
              <th class="pb-3 pt-3 px-3">Alt. Contact</th>
              <th class="pb-3 pt-3 px-3">KRA Pin Number</th>
              <th class="pb-3 pt-3 px-3">Region</th>
              <th class="pb-3 pt-3 px-3">City</th>
              <th class="pb-3 pt-3 px-3">Agents</th>
              <th class="pb-3 pt-3 px-3">Payment Term</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3">KYC Docs</th>
              <th class="pb-3 pt-3 px-3">Referees</th>
              <th class="pb-3 pt-3 px-3" />
            </tr>
            <tr v-for="pending in pending.data" :key="pending.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.date_created }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ pending.date_created }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.number }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ pending.name }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.name }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ pending.name }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.channel }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ pending.channel }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.address }}
                </Link>
                <Link v-else href="#">{{ pending.address }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.phone }}
                </Link>
                <Link v-else href="#">{{ pending.phone }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.alternative_phone }}
                </Link>
                <Link v-else href="#">{{ pending.alternative_phone }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.kra_pin_number }}
                </Link>
                <Link v-else href="#">{{ pending.kra_pin_number }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.region }}
                </Link>
                <Link v-else href="#">{{ pending.region }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.city }}
                </Link>
                <Link v-else href="#">{{ pending.city }}</Link>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${pending.id}/users`" title="Edit Customer" @click="manageAgents(pending)">
                  Manage <sup><small class="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-green-500 text-white ml-2 rounded-full">{{ pending.users.length }}</small></sup>
                </a>
                <Link v-else href="#">-</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.payment_term }}
                </Link>
                <Link v-else href="#">{{ pending.payment_term }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.status }}
                </Link>
                <Link v-else href="#">{{ pending.status }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  {{ pending.documents.length }}
                </Link>
                <Link v-else href="#">{{ pending.documents.length }}</Link>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${pending.id}/edit`" title="Edit Customer">
                  <ol class="list-decimal">
                    <li v-for="preferee in pending.referees" :key="preferee.id">
                      <p> Name: <strong>{{ preferee.name }}</strong>,<strong>  {{ preferee.phone_number }}</strong></p>
                    </li>
                  </ol>
                </a>
                <a v-else href="#">
                  <ol class="list-decimal">
                    <li v-for="preferee in pending.referees" :key="preferee.id">
                      <p> Name: <strong>{{ preferee.name }}</strong>,<strong>  {{ preferee.phone_number }}</strong></p>
                    </li>
                  </ol>
                </a>
              </td>
              <td class="w-px border-t">
                <a v-if="userObj.role === 'admin' || userObj.teams.includes('Finance')" href="#" class="flex items-center px-3" tabindex="-1" title="Edit Customer" @click="approve(pending)">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </a>
              </td>
            </tr>
          </table>
        </div>
        <div v-else class="bg-white rounded-md shadow overflow-x-auto">
          <p class="p-5">No data found</p>
        </div>
        <pagination class="mt-6" :links="pending.links" />
      </div>
      <div id="tabs-profileFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-profile-tabFill">
        <div class="flex items-center justify-between mb-6" />
        <div v-if="customers.data.length > 0" class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Created on</th>
              <th class="pb-3 pt-3 px-3">Number</th>
              <th class="pb-3 pt-3 px-3">Name</th>
              <th class="pb-3 pt-3 px-3">Channel</th>
              <th class="pb-3 pt-3 px-3">Branch</th>
              <th class="pb-3 pt-3 px-3">Physcial Address</th>
              <th class="pb-3 pt-3 px-3">Contact</th>
              <th class="pb-3 pt-3 px-3">Alt. Contact</th>
              <th class="pb-3 pt-3 px-3">KRA Pin Number</th>
              <th class="pb-3 pt-3 px-3">Region</th>
              <th class="pb-3 pt-3 px-3">City</th>
              <th class="pb-3 pt-3 px-3">Agents</th>
              <th class="pb-3 pt-3 px-3">KYC Docs</th>
              <th class="pb-3 pt-3 px-3">Referees</th>
              <th class="pb-3 pt-3 px-3">Approved By</th>
              <th class="pb-3 pt-3 px-3">Approved On</th>
              <th class="pb-3 pt-3 px-3">Payment Term</th>
              <th class="pb-3 pt-3 px-3">Status</th>              
              <th class="pb-3 pt-3 px-3" />
            </tr>
            <tr v-for="customer in customers.data" :key="customer.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.date_created }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.date_created }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.number }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.number }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.name }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.name }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.channel }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.channel }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.customer_branch }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.customer_branch }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.address }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.address }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.phone }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.phone }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.alternative_phone }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.alternative_phone }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.kra_pin_number }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.kra_pin_number }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.region }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.region }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.city }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.city }}</Link>
              </td>

              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/users`" title="Edit Customer" @click="manageAgents(customer)">
                  Manage <sup><small class="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-green-500 text-white ml-2 rounded-full">{{ customer.users.length }}</small></sup>
                </a>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">-</Link>
              </td>
              <td class="border-t">
                <span
                  v-if="
                    customer.documents.length
                      && userObj.role === 'admin'
                      || userObj.teams.includes('Finance')
                  "
                >
                  <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer" @click="viewKyc(customer)">
                    <span v-if="customer.documents.length">View </span><sup><small class="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-green-500 text-white ml-2 rounded-full">{{ customer.documents.length }}</small></sup>
                  </a>
                </span>
                <span v-else> - </span>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  <ol class="list-decimal">
                    <li v-for="creferee in customer.referees" :key="creferee.id">
                      <p> Name: <strong>{{ creferee.name }}</strong>,<strong>  {{ creferee.phone_number }}</strong></p>
                    </li>
                  </ol>
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">
                  <ol class="list-decimal">
                    <li v-for="creferee in customer.referees" :key="creferee.id">
                      <p> Name: <strong>{{ creferee.name }}</strong>,<strong>  {{ creferee.phone_number }}</strong></p>
                    </li>
                  </ol>
                </Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.approved_by }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.approved_by }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.approved_on }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.approved_on }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.payment_term }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.payment_term }}</Link>
              </td>
              <td class="border-t">
                <Link v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.status }}
                </Link>
                <Link v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.status }}</Link>
              </td>
              <td class="w-px border-t">
                <a v-if="userObj.role === 'admin'" :href="`/customers/${customer.id}/edit`" class="flex items-center px-3" tabindex="-1" title="Edit Customer">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </a>
              </td>
            </tr>
          </table>
        </div>
        <div v-else class="bg-white rounded-md shadow overflow-x-auto">
          <p class="p-5">No data found</p>
        </div>
        <pagination class="mt-6" :links="customers.links" />
      </div>
      <div id="tabs-declinedFill" class="tab-pane fade" role="tabpanel" aria-labelledby="tabs-declined-tabFill">
        <div class="flex items-center justify-between mb-6" />
        <div v-if="declined.data.length > 0" class="bg-white rounded-md shadow overflow-x-auto">
          <table class="w-full whitespace-nowrap">
            <tr class="text-left font-bold">
              <th class="pb-3 pt-3 px-3">Created on</th>
              <th class="pb-3 pt-3 px-3">Number</th>
              <th class="pb-3 pt-3 px-3">Name</th>
              <th class="pb-3 pt-3 px-3">Channel</th>
              <th class="pb-3 pt-3 px-3">Branch</th>
              <th class="pb-3 pt-3 px-3">Physcial Address</th>
              <th class="pb-3 pt-3 px-3">Contact</th>
              <th class="pb-3 pt-3 px-3">Alt. Contact</th>
              <th class="pb-3 pt-3 px-3">KRA Pin Number</th>
              <th class="pb-3 pt-3 px-3">Region</th>
              <th class="pb-3 pt-3 px-3">City</th>
              <th class="pb-3 pt-3 px-3">Agents</th>
              <th class="pb-3 pt-3 px-3">KYC Docs</th>
              <th class="pb-3 pt-3 px-3">Referees</th>
              <th class="pb-3 pt-3 px-3">Declined By</th>
              <th class="pb-3 pt-3 px-3">Declined On</th>
              <th class="pb-3 pt-3 px-3">Declined Reason</th>
              <th class="pb-3 pt-3 px-3">Payment Term</th>
              <th class="pb-3 pt-3 px-3">Status</th>
              <th class="pb-3 pt-3 px-3" />
            </tr>
            <tr v-for="customer in declined.data" :key="customer.id" class="hover:bg-orange-100 focus-within:bg-gray-100">
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.date_created }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.date_created }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.number }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.name }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.name }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.name }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.channel }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.channel }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.customer_branch }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.customer_branch }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.address }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.address }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.phone }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.phone }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.alternative_phone }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.alternative_phone }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.kra_pin_number }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.kra_pin_number }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.region }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.region }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.city }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.city }}</a>
              </td>

              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/users`" title="Edit Customer">
                  Manage <sup><small class="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-green-500 text-white ml-2 rounded-full">{{ customer.users.length }}</small></sup>
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">-</a>
              </td>
              <td class="border-t">
                <span
                  v-if="
                    customer.documents.length
                      && userObj.role === 'admin'
                      || userObj.teams.includes('Finance')
                  "
                >
                  <a class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer" @click="viewKyc(customer)">
                    <span v-if="customer.documents.length">View </span><sup><small class="text-xs inline-block py-1 px-2.5 leading-none text-center whitespace-nowrap align-baseline font-bold bg-green-500 text-white ml-2 rounded-full">{{ customer.documents.length }}</small></sup>
                  </a>
                </span>
                <span v-else> - </span>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  <ol class="list-decimal">
                    <li v-for="creferee in customer.referees" :key="creferee.id">
                      <p> Name: <strong>{{ creferee.name }}</strong>,<strong>  {{ creferee.phone_number }}</strong></p>
                    </li>
                  </ol>
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-orange-500" href="#">
                  <ol class="list-decimal">
                    <li v-for="creferee in customer.referees" :key="creferee.id">
                      <p> Name: <strong>{{ creferee.name }}</strong>,<strong>  {{ creferee.phone_number }}</strong></p>
                    </li>
                  </ol>
                </a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.declined_by }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.declined_by }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.declined_on }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.declined_on }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.declined_reason }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.declined_reason }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.payment_term }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.payment_term }}</a>
              </td>
              <td class="border-t">
                <a v-if="userObj.role === 'admin'" class="flex items-center px-3 py-3 focus:text-orange-500" :href="`#/customers/${customer.id}/edit`" title="Edit Customer">
                  {{ customer.status }}
                </a>
                <a v-else class="flex items-center px-3 py-3 focus:text-gray-700" href="#">{{ customer.status }}</a>
              </td>
              <td class="w-px border-t">
                <a v-if="userObj.role === 'admin'" :href="`#/customers/${customer.id}/edit`" class="flex items-center px-3" tabindex="-1" title="Edit Customer">
                  <icon name="cheveron-right" class="block w-6 h-6 fill-gray-400" />
                </a>
              </td>
            </tr>
          </table>
        </div>
        <div v-else class="bg-white rounded-md shadow overflow-x-auto">
          <p class="p-5">No data found</p>
        </div>
        <pagination class="mt-6" :links="declined.links" />
      </div>
    </div>
  </div>
  <div v-if="isOpen" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 md:px-6 sm:flex md:flex modal-wrapper w-full">
            <h1 style="font-size: 24px;">
              Manage Agents for: {{ selectedCustomer.name }} - {{ selectedCustomer.city }}, {{ selectedCustomer.region }}
            </h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-0 sm:p-0 sm:pb-0">
            <div class="">
              <div class="flex flex-wrap -mb-1 -mr-6 pl-8 pr-8 bg-white rounded-md shadow">
                <select-input v-model="user" :error="userError" class="pb-1 pr-6 pt-6 w-full lg:w-full">
                  <option :value="null">
                    Select user
                  </option>
                  <option
                    v-for="user in users"
                    :key="user.id"
                    :value="user.id"
                  >
                    {{ user.first_name }} {{ user.last_name }}
                  </option>
                </select-input>
              </div>
            </div>
            <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
              <div v-if="userList.length > 0" class="bg-white rounded-md shadow overflow-x-auto">
                <table class="w-full whitespace-nowrap">
                  <tr class="text-left font-bold">
                    <th class="pb-3 pt-3 px-3">User Name</th>
                    <th class="pb-3 pt-3 px-3">Email Address</th>
                    <th class="pb-3 pt-3 px-3 flex items-center justify-end">Manage</th>
                  </tr>
                  <tr v-for="userObj in userList" :key="userObj.id">
                    <td class="pb-3 pt-3 px-3">{{ userObj.first_name }} {{ userObj.last_name }}</td>
                    <td class="pb-3 pt-3 px-3">{{ userObj.email }}</td>
                    <td class="pb-3 pt-3 px-3 flex items-center justify-end">
                      <a href="#" @click="detachUser(userObj)">
                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                          <path stroke-linecap="round" stroke-linejoin="round" d="M14.74 9l-.346 9m-4.788 0L9.26 9m9.968-3.21c.342.052.682.107 1.022.166m-1.022-.165L18.16 19.673a2.25 2.25 0 01-2.244 2.077H8.084a2.25 2.25 0 01-2.244-2.077L4.772 5.79m14.456 0a48.108 48.108 0 00-3.478-.397m-12 .562c.34-.059.68-.114 1.022-.165m0 0a48.11 48.11 0 013.478-.397m7.5 0v-.916c0-1.18-.91-2.164-2.09-2.201a51.964 51.964 0 00-3.32 0c-1.18.037-2.09 1.022-2.09 2.201v.916m7.5 0a48.667 48.667 0 00-7.5 0" />
                        </svg>
                      </a>
                    </td>
                  </tr>
                </table>
              </div>
              <div v-else class="bg-white rounded-md shadow">
                <p class="p-4">No data found.</p>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
              <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
                <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="attachUser()">
                  Attach
                </button>
              </span>
              <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
                <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeModal">
                  Cancel
                </button>
              </span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isOpenDetach" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px;">Remove Agent</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              You are about to detach agent from customer. Do you wish to continue?
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submitDetach">
                Yes
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeDetachModal">
                No
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isOpenAttachMessage" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px;">Attach/Detach Agent</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              {{ attachMessage }}
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <!--
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submitDetach">
                Yes
              </button>
            </span> -->
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeDetachModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isOpenKyc" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-1/2" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px;">KYC <span v-if="!approvedView">Approval/Decline</span></h1>
          </div>
          <div id="accordionExample" class="accordion">
            <div class="accordion-item bg-white border border-gray-200">
              <h2 id="headingOne" class="accordion-header mb-0">
                <button
                  v-for="doc in documents" :key="doc.id"
                  class="
                  accordion-button
                  relative
                  flex
                  items-center
                  w-full
                  py-4
                  px-5
                  text-base text-gray-800 text-left
                  bg-white
                  border-0
                  rounded-none
                  transition
                  focus:outline-none" type="button" data-bs-toggle="collapse" :data-bs-target="`#collapse${doc.id}`" aria-expanded="true"
                  :aria-controls="`collapse${doc.id}`"
                >
                  {{ doc.file }}
                </button>
              </h2>
              <div
                v-for="dox in documents" :id="`collapse${dox.id}`"
                :key="dox.id" class="accordion-collapse collapse" aria-labelledby="headingOne"
                data-bs-parent="#accordionExample"
              >
                <div class="accordion-body py-4 px-5">
                  <img :src="`storage/${dox.path}`" />
                </div>
              </div>
            </div>
            <h3 v-if="!approvedView" class="p-5">You are about to approve or decline this customer, do you wish to continue?</h3>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4 hidden">
            <div v-if="documents.length > 0" class="mb-4">
              <div class="p-5">
                <ul 
                  id="tabs-tab" class="nav nav-tabs flex flex-col md:flex-row flex-wrap list-none border-b-0 pl-0 mb-4"
                  role="tablist"
                >
                  <li v-for="(doc, ixx) in documents" :key="doc.id" class="nav-item" role="presentation">
                    <a
                      :id="`tabs-${doc.id}-tab`" :href="`#tabs-${doc.id}`" class="
                      nav-link
                      block
                      font-medium
                      text-xs
                      leading-tight
                      uppercase
                      border-x-0 border-t-0 border-b-2 border-transparent
                      px-6
                      py-3
                      my-2
                      hover:border-transparent hover:bg-gray-100
                      focus:border-transparent
                    " data-bs-toggle="pill" :data-bs-target="`#tabs-${doc.id}`" role="tab" :aria-controls="`tabs-${doc.id}`"
                    >
                      View: {{ doc.file }}
                    </a>
                  </li>
                </ul>
                <div id="tabs-tabContent" class="tab-content">
                  <div v-for="(dox, idx) in documents" :id="`tabs-${dox.id}`" :key="dox.id" class="tab-pane fade" role="tabpanel" :aria-labelledby="`tabs-${dox.id}-tab`">
                    <img :src="`storage/${dox.path}`" />
                  </div>
                </div>
              </div>
              <h3 class="p-5">You are about to approve or decline this customer, do you wish to continue?</h3>
            </div>
            <div v-else>
              There are no KYC documents found.
            </div>
          </div>
          <div v-if="!approvedView" class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span v-if="documents.length > 0" class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-green-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-green-500 focus:outline-none focus:border-green-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submitApprove">
                Approve
              </button>
            </span>
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-400 focus:outline-1 focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="openDecline">
                Decline
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeApproveModal">
                Close
              </button>
            </span>
          </div>
          <div v-else class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span v-if="!approvedView" class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-400 focus:outline-1 focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="openDecline">
                Decline
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeApproveModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <div v-if="isOpenDecline" class="fixed z-10 inset-0 overflow-y-auto">
    <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75" />
      </div>
      <!-- This element is to trick the browser into centering the modal contents. -->
      <span class="hidden sm:inline-block sm:align-middle sm:h-screen" />
      <div class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle w-1/2" role="dialog" aria-modal="true" aria-labelledby="modal-headline">
        <form>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex modal-wrapper">
            <h1 style="font-size: 24px;">Customer Decline</h1>
          </div>
          <div class="bg-white px-4 pt-0 pb-4 sm:p-6 sm:pb-4">
            <div class="mb-4">
              <div class="p-0">
                <select-input v-model="decline_reason" class="pb-1 pr-6 pt-6 w-full lg:w-full" label="Decline reason">
                  <option :value="null">
                    Select decline reason
                  </option>
                  <option
                    v-for="reason in reasons"
                    :key="reason.id"
                    :value="reason.id"
                  >
                    {{ reason.reason }}
                  </option>
                </select-input>
                <div v-if="$props.errors" class="form-error">{{ $props.errors.decline_reason }}</div>
              </div>
            </div>
          </div>
          <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
            <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-transparent px-4 py-2 bg-red-600 text-base leading-6 font-medium text-white shadow-sm hover:bg-red-400 focus:outline-1 focus:border-red-700 focus:shadow-outline-red sm:text-sm sm:leading-5" @click="submitDecline">
                Decline
              </button>
            </span>
            <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
              <button type="button" class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-gray-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue sm:text-sm sm:leading-5" @click="closeDeclineModal">
                Close
              </button>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
  
<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import pickBy from 'lodash/pickBy'
import Layout from '@/Shared/Layout'
import throttle from 'lodash/throttle'
import mapValues from 'lodash/mapValues'
import SearchFilter from '@/Shared/SearchFilter'
import Pagination from '@/Shared/Pagination'
import TextInput from '@/Shared/TextInput'
import SelectInput from '@/Shared/SelectInput'
import axios from 'axios'
  
export default {
  components: {
    Head,
    Icon,
    Link,
    SearchFilter,
    Pagination,
    TextInput,
    SelectInput,
  },
  layout: Layout,
  props: {
    filters: Object,
    customers: Object,
    pending: Object,
    declined: Object,
    users: Object,
    reasons: Object,
    errors: Object,
  },
  data() {
    return {
      form: {
        search: this.filters.search,
      },
      isOpen: false,
      isOpenKyc: false,
      isOpenDecline: false,
      selectedCustomer: null,
      user: null,
      userList: null,
      isOpenDetach: false,
      isOpenAttach: false,
      isOpenAttachMessage: false,
      attachMessage: false,
      documents: null,
      approvedView: false,
      decline_reason: null,
    }
  },
  computed: {
    userObj() {
      return this.$inertia.page.props.auth.user
    },
  },
  watch: {
    form: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get('/customers', pickBy(this.form), { preserveState: true })
      }, 150),
    },
  },
  methods: {
    reset() {
      this.form = mapValues(this.form, () => null)
    },
    manageAgents(item) {
      this.isOpen = true
      this.selectedCustomer = item
      axios.get(`/customers/${this.selectedCustomer.id}/users`).then(response => {
        this.userList = response.data.users
      })
    },
    openDecline() {
      this.isOpenDecline = true
    },
    closeModal() {
      this.isOpen = false
      this.isOpenDecline = false
    },
    closeDeclineModal() {
      this.isOpen = false
      this.isOpenDecline = false
    },
    closeDetachModal() {
      this.isOpenDetach = false
      this.isOpenAttachMessage = false
    },
    attachedUsers() {
      axios.get(`/customers/${this.selectedCustomer.id}/users`).then(response => {
        this.userList = response.data.users
      })
    },
    attachUser() {
      axios.post(`/customers/${this.selectedCustomer.id}/attach-users`, { user: this.user }).then(response => {
        if (!response.data.message) {
          this.userList = response.data.users
          this.isOpenAttachMessage = true
          this.attachMessage = 'Agent attached from customer successfully.'
        } else {
          this.isOpenAttachMessage = true
          this.attachMessage = response.data.message
        }
      })
    },
    detachUser(item) {
      this.isOpenDetach = true
      this.user = item.id
    },
    submitDetach() {
      axios.post(`/customers/${this.selectedCustomer.id}/detach-user`, { user: this.user }).then(response => {
        if (!response.data.message) {
          this.userList = response.data.users
          this.isOpenDetach = false
          this.isOpenAttachMessage = true
          this.attachMessage = 'Agent detached from customer'
        } else {
          this.isOpenAttachMessage = true
          this.attachMessage = response.data.message
        }
      })
    },
    approve(item) {
      this.isOpenKyc = true
      this.documents = item.documents
      this.selectedCustomer = item
    },
    closeApproveModal() {
      this.isOpenKyc = false
      this.approvedView = false
    },
    viewKyc(item) {
      this.approvedView = true
      this.isOpenKyc = true
      this.documents = item.documents
    },
    submitApprove() {
      axios.post(`/customers/${this.selectedCustomer.id}/approve`).then(response => {
        if (response.data.message) {
          this.isOpenKyc = false
          alert(response.data.message)
          this.$router.go()	
        }
      })
    },
    submitDecline() {
      let requestForm = {}
      requestForm.customer = this.selectedCustomer.id
      requestForm.decline_reason = this.decline_reason
      requestForm._method = 'post'
      this.$inertia.post(`/customers/${this.selectedCustomer.id}/decline`, requestForm, {
        onSuccess: () => {
          this.show = true
          this.isOpenDecline = false
          this.isOpenKyc = false
        },
      })
    },
  },
}
</script>
  